import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import StrapiImage from '@/components/StrapiImage/StrapiImage';
import PageMargins from '@/components/ui/PageMargins/PageMargins';

import {
  FormWrapper,
  Heading,
  ImageWrapper,
  Wrapper,
} from './DefaultHero.style';

const DefaultHero = ({ headline, pictures, formComponent }) => {
  return (
    <PageMargins>
      <Wrapper>
        <Stack alignItems="center">
          <Heading>{headline}</Heading>
          {pictures ? (
            <ImageWrapper>
              <StrapiImage data={pictures} />
            </ImageWrapper>
          ) : null}
        </Stack>
        <FormWrapper>{formComponent}</FormWrapper>
      </Wrapper>
    </PageMargins>
  );
};

DefaultHero.propTypes = {
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  pictures: PropTypes.object,
  formComponent: PropTypes.node,
};

DefaultHero.defaultProps = {
  pictures: null,
  formComponent: null,
};

export default DefaultHero;
